export default function Card({ title, children }) {
  return (
    <div className="p-4 max-w-md bg-white rounded-lg border shadow-md sm:p-8 "> {/* dark:bg-gray-800 dark:border-gray-700 */}
      <div className="flex justify-between items-center mb-4">
        <h5 className="text-xl font-bold leading-none text-gray-900 ">{title}</h5> {/* dark:text-white */}
        {/* <a href="#" class="text-sm font-medium text-blue-600 hover:underline "> dark:text-blue-500
          View all
        </a> */}
      </div>
      <div className="flow-root">
        {children}
      </div>
    </div>
  )
}